import { env } from "@/config/env"

/* ─────────────────────────────────────────────────────────────────────────────
 * Medicao de audiencia — Umami.
 *
 * Escolhido por ser sem cookie e sem identificador persistente: nao ha
 * fingerprint, nao ha perfil de individuo, e nada aqui exige consentimento sob
 * a LGPD. Isso importa por um motivo concreto — o banner de cookies deste site
 * nao bloqueia script nenhum. Com uma ferramenta baseada em cookie (GA4, por
 * exemplo) o "Recusar" precisaria passar a bloquear de verdade, e ate la o
 * banner estaria mentindo para o visitante.
 *
 * O script e injetado por codigo, e nao escrito no index.html, para que a
 * medicao simplesmente nao exista quando `VITE_UMAMI_WEBSITE_ID` esta vazia —
 * caso do ambiente local e da suite de testes. Uma tag fixa no HTML mandaria
 * pageview de desenvolvimento para o painel do cliente.
 * ────────────────────────────────────────────────────────────────────────── */

const SCRIPT_MARKER = "data-dimpet-analytics"

export function initAnalytics(): void {
  if (!env.umamiWebsiteId) return

  // O StrictMode do React monta duas vezes em desenvolvimento. Sem esta
  // guarda, seriam dois scripts e cada visita contaria em dobro.
  if (document.querySelector(`script[${SCRIPT_MARKER}]`)) return

  const script = document.createElement("script")
  script.src = env.umamiScriptUrl
  script.defer = true
  script.setAttribute(SCRIPT_MARKER, "")
  script.setAttribute("data-website-id", env.umamiWebsiteId)

  document.head.appendChild(script)
}
